// src/components/Activities/Speakers.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Speakers.css';

const Speakers = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  // Data from the updated document
  const speakers = {
    specialGuest: [
      {
        id: 'sg1',
        name: "H.E. Senator Ahmed Bola Tinubu, GCFR",
        title: "President, Federal Republic of Nigeria",
        organization: "The Presidency",
        topic: "Special Guest of Honour",
        image: "/images/president-tinubu.jpg",
        status: "Special Guest"
      }
    ],
    chairman: [
      {
        id: 'c1',
        name: "H.E. Senator George Akume, CON",
        title: "Secretary to the Government of the Federation",
        organization: "Government of the Federation",
        topic: "Chairman's Opening Remark",
        image: "/images/speakers/sgf-akume.jpg",
        status: "Confirmed",
        isChairman: true
      }
    ],
    confirmed: [
      {
        id: 1,
        name: "Hon. Moses O.T. Owharo",
        title: "Chairman, Planning and Organizing Committee",
        organization: "Africa Business Ventures & Investment Group",
        topic: "AICIS 2025 Global Summit Overview",
        image: "/images/speakers/moses-owharo.jpeg",
        status: "Confirmed"
      },
      {
        id: 2,
        name: "Mr. Obaro Odeghe",
        title: "Executive Director, Development Business Banking Group",
        organization: "First City Monument Bank Plc (FCMB)",
        topic: "Banking and Financial Inclusion for Climate Action",
        image: "/images/speakers/Obaro-Odeghe.png",
        status: "Confirmed"
      },
      {
        id: 3,
        name: "Dame. Dr. Adaora Umeoji OON",
        title: "Group Managing Director/CEO",
        organization: "Zenith Bank PLC",
        topic: "Financing Africa's Green Infrastructure",
        image: "/images/speakers/Dame-Adaora.jpg",
        status: "Confirmed"
      },
      {
        id: 4,
        name: "Prof. Muhammed Tawfiq Ladan",
        title: "Professor of Law",
        organization: "Faculty of Law, Ahmadu Bello University, Zaria",
        topic: "Legal and Institutional Frameworks for Advancing Climate Justice and Sustainable Infrastructure in Africa",
        image: "/images/speakers/Tawfiq-Ladan.png",
        status: "Confirmed"
      },
      {
        id: 5,
        name: "Ms. Faith Iroham",
        title: "CEO",
        organization: "Gove Energy",
        topic: "Advancing Sustainable Energy Solutions: The Role of Indigenous Companies in Africa's Green Transition",
        image: "/images/speakers/Faith-Iroham.jpeg",
        status: "Confirmed"
      },
      {
        id: 6,
        name: "DR. Eruani Azibapu Godbless ",
        title: "CEO",
        organization: "Azikel Group",
        topic: "Catalyzing Nigeria's Green Investment Revolution: Advancing the Renewed Hope Agenda for Climate-Resilient Growth",
        image: "/images/speakers/eruani.jpg",
        status: "Confirmed"
      },
      {
        id: 7,
        name: "Prof. Chris Schrage",
        title: "Advisor, Economic, Women & Business Development, CGBP",
        organization: "University of Northern Iowa, USA",
        topic: "Leveraging Global Partnerships and Community Engagement for Sustainable Economic Development in Africa",
        image: "/images/speakers/profChris.jpg",
        status: "Confirmed"
      },
      {
        id: 8,
        name: "Mr Donald Wokoma",
        title: "CEO",
        organization: "Equipment Leasing Registration Authority (ELRA)",
        topic: "Equipment Leasing Registration",
        image: "/images/speakers/Donald-Wokoma.png",
        status: "Confirmed"
      }
    ],
    inView: [
      {
        id: 9,
        name: "Prof. Charles Chukwuma Soludo, CFR",
        title: "Governor",
        organization: "Anambra State Government",
        topic: "State-Level Climate Action and Sustainable Development",
        image: "/images/speakers/Chukwuma-Soludo.jpg",
        status: "In View"
      },
      {
        id: 10,
        name: "Mrs. Didi Esther Walson Jack",
        title: "Head of Civil Service of the Federation",
        organization: "Government of the Federation",
        topic: "Civil Service Leadership in Climate Governance",
        image: "/images/speakers/Esther-Walson.jpg",
        status: "In View"
      },
      {
        id: 11,
        name: "Mr Rabiu Abdullahi Umar",
        title: "The Authority Chief Executive Nigerian Midstream & Downstream Petroleum Regulatory Authority (NMDPRA)",
        organization: "Nigerian Midstream & Downstream Petroleum Regulatory Authority (NMDPRA)",
        topic: "Petroleum Industry Regulation and Energy Transition",
        image: "/images/speakers/Abdullahi-Umar.jpeg",
        status: "In View"
      }
    ],
    invited: [
      {
        id: 12,
        name: "Sir Mohamed Mansour",
        title: "Chairman",
        organization: "Mansour Group",
        topic: "To Be Communicated",
        image: "/images/speakers/mansour-mohamed.jpg",
        status: "Invited"
      },
      {
        id: 13,
        name: "Florian Seibel",
        title: "The President & CEO,",
        organization: "Quantum Systems, Germany ",
        topic: "To Be Communicated",
        image: "/images/speakers/President-Quantum.jpg",
        status: "Invited"
      },
      {
        id: 14,
        name: "Palmer Luckey",
        title: "Founder",
        organization: "Anduril Industries, Inc., USA",
        topic: "To Be Communicated",
        image: "/images/speakers/Palmer_Luckey_01.jpg",
        status: "Invited"
      },
      {
        id: 15,
        name: "Professor Nnanyelugo Martin Ike Muonso",
        title: "Director General",
        organization: "Raw Materials Research and Development Council (RMRDC)",
        topic: "Raw Materials Development and Industrialization",
        image: "/images/speakers/Nnanyelugo-Martin.jpg",
        status: "Invited"
      },
      {
        id: 16,
        name: "Hon. Festus Keyamo SAN, CON, FCIAirb (UK)",
        title: "Minister of Aviation & Aerospace Development",
        organization: "Federal Ministry of Aviation & Aerospace Development",
        topic: "Aviation Infrastructure and Aerospace Development",
        image: "/images/speakers/Festus-Keyamo.jpg",
        status: "Invited"
      },
      {
        id: 17,
        name: "Emmanuella Arukwe",
        title: "The Managing Director",
        organization: "NNPC Foundation Limited/Gte",
        topic: "Energy Sector Development and Corporate Social Responsibility",
        image: "/images/speakers/Emmanuella-Arukwe.jpg",
        status: "Invited"
      },
      {
        id: 18,
        name: "Prof. Taiwo Oyedele",
        title: "The Honourable Minister",
        organization: "Federal Ministry of Finance & Coordinating Ministry of the Economy",
        topic: "Economic Policy and Investment Strategy",
        image: "/images/speakers/Taiwo-Oyedele.png",
        status: "Invited"
      },
      {
        id: 19,
        name: "Mrs Oritsemeyewa Eyesan",
        title: "The Commission Chief Executive (CCE)",
        organization: "Nigerian Upstream Petroleum Regulatory Commission (NUPRC)",
        topic: "Upstream Petroleum Regulation and Investment",
        image: "/images/speakers/Oritsemeyewa-Eyesan.jpg",
        status: "Invited"
      },
      {
        id: 20,
        name: "Abba Aliyu",
        title: "The Managing Director",
        organization: "Rural Electrification Agency (REA)",
        topic: "Rural Electrification and Energy Access",
        image: "/images/speakers/Abba-Aliyu.jpg",
        status: "Invited"
      },
      {
        id: 21,
        name: "Distinguished Senator Godswill Obot Akpabio, CON",
        title: "President of the Senate",
        organization: "Federal Republic of Nigeria",
        topic: "Legislative Framework for Infrastructure Development",
        image: "/images/speakers/akpabio.jpg",
        status: "Dispatched"
      },
      {
        id: 22,
        name: "",
        title: "The President & Chief Executive Officer",
        organization: "Dangote Group",
        topic: "Industrialization and Private Sector Investment",
        image: "/images/speakers/dangote.jpg",
        status: "Dispatched"
      },
      {
        id: 23,
        name: "Dr. Lucky Orimisan Aiyedatiwa",
        title: "Executive Governor",
        organization: "Ondo State Government",
        topic: "State-Level Climate Action and Infrastructure Development",
        image: "/images/speakers/Lucky-Orimisan.jpg",
        status: "Invited"
      },
      {
        id: 24,
        name: "His Excellency, Pastor Umo Eno",
        title: "Executive Governor",
        organization: "Akwa Ibom State Government",
        topic: "State-Level Infrastructure and Investment",
        image: "/images/speakers/umo-eno.jpg",
        status: "Invited"
      },
      {
        id: 25,
        name: "Walter Akpani",
        title: "CEO",
        organization: "Providus Bank",
        topic: "Banking and Financial Services for Development",
        image: "/images/speakers/Walter Akpani.png",
        status: "Invited"
      },
      {
        id: 26,
        name: "Oliver Alawuba",
        title: "Chief Executive Officer",
        organization: "United Bank for Africa Plc (UBA)",
        topic: "Financing Africa's Development",
        image: "/images/speakers/ceo-uba.jpg",
        status: "Invited"
      },
      {
        id: 27,
        name: "Sa'idu Ahmed Alkali",
        title: " The Honourable Minister",
        organization: "Federal Ministry of Transportation",
        topic: "Transportation Infrastructure Development",
        image: "/images/speakers/Saidu-Ahmed.jpg",
        status: "Invited"
      },
      {
        id: 28,
        name: "Hon. Adegboyega Oyetola",
        title: "Federal Ministry of Marine & Blue Economy",
        organization: "Federal Ministry of Marine & Blue Economy",
        topic: "Blue Economy and Maritime Development",
        image: "/images/speakers/Adegboyega-Oyetola.jpg",
        status: "Invited"
      },
      {
        id: 29,
        name: "Johnson-Akinnawo",
        title: "Chief Executive Officer",
        organization: "Nigerian Bulk Electricity Trading Plc",
        topic: "Bulk Electricity Trading and Energy Policy",
        image: "/images/speakers/Johnson-Akinnawo.jpg",
        status: "Invited"
      },
      {
        id: 30,
        name: "Gen. Christopher Gwabin Musa (RTD) OFR",
        title: "Honourable Minister of Defence",
        organization: "Federal Ministry of Defence",
        topic: "Security and Infrastructure Development",
        image: "/images/speakers/Christopher-Gwabin.jpg",
        status: "Invited"
      },
      {
        id: 31,
        name: "Engr Dr Emeka Agbasi",
        title: "The Managing Director",
        organization: "Federal Road Maintenance Agency (FERMA)",
        topic: "Road Infrastructure and Maintenance",
        image: "/images/speakers/Emeka Agbasi.jpg",
        status: "Invited"
      },
      {
        id: 32,
        name: "Abubakar Suleiman",
        title: "Chief Executive Officer",
        organization: "Sterling Bank",
        topic: "Banking and Financial Inclusion",
        image: "/images/speakers/Abubakar Suleiman.jpg",
        status: "Invited"
      },
      {
        id: 3,
        name: "HASSAN IMAM (F.C.I.B)",
        title: "Chief Executive Officer",
        organization: "Keystone Bank",
        topic: "Financial Services and Development",
        image: "/images/speakers/HASSAN-IMAM.jpg",
        status: "Invited"
      },
      {
        id: 31,
        name: "Dr. Olufemi Bakre",
        title: "Chief Executive Officer",
        organization: "Parallex Bank Limited",
        topic: "Banking and Financial Services",
        image: "/images/speakers/Olufemi-Bakre.jpg",
        status: "Invited"
      },
      {
        id: 32,
        name: "Mohamed Eledarous",
        title: "The Managing Director",
        organization: "Arab Contractors Nigeria Limited",
        topic: "Construction and Infrastructure Development",
        image: "/images/speakers/Mohamed Eledarous.jpg",
        status: "Invited"
      },
      {
        id: 33,
        name: "Engr. Goni Musa Sheikh",
        title: "Julius Berger Nigeria",
        organization: "Julius Berger Nigeria",
        topic: "Engineering and Construction",
        image: "/images/speakers/Goni-Musa.jpg",
        status: "Invited"
      },
      {
        id: 34,
        name: "Professor (Engr.) Nentawe Goshwe Yilwatda",
        title: "All Progressive Congress (APC)",
        organization: "APC",
        topic: "Political Leadership and Development",
        image: "/images/speakers/Nentawe-Goshwe.jpg",
        status: "Invited"
      },
      {
        id: 35,
        name: "Jumoke Oduwole MFR",
        title: "The Honourable Minister",
        organization: "Federal Ministry of Industry, Trade and Investment",
        topic: "Industrialization and Investment Promotion",
        image: "/images/speakers/Jumoke-Oduwole.jpg",
        status: "Invited"
      },
      {
        id: 36,
        name: "Dr. Lucky Orimisan Aiyedatiwa",
        title: "Executive Governor",
        organization: "Ondo State Government",
        topic: "State-Level Climate Action and Infrastructure Development",
        image: "/images/speakers/Lucky-Orimisan.jpg",
        status: "Invited"
      },
      {
        id: 37,
        name: "Mrs. Olubunmi Kuku",
        title: "Federal Airports Authority of Nigeria (FAAN)",
        organization: "FAAN",
        topic: "Aviation Infrastructure and Airport Development",
        image: "/images/speakers/olubunmi-kuku.jpg",
        status: "Invited"
      },
      {
        id: 39,
        name: "Dr. George Elombi",
        title: "African Export-Import Bank (Afreximbank)",
        organization: "Afreximbank",
        topic: "Trade Finance and African Development",
        image: "/images/speakers/george-elombi.jpg",
        status: "Invited"
      },
       {
        id: 40,
        name: "Mrs. Odunayo Sanya",
        title: "Executive Director",
        organization: "MTN Nigeria Foundation",
        topic: "To Be Commmunicated",
        image: "/images/speakers/Odunayo-Sanya.jpg",
        status: "Invited"
      },
    ]
  };

  const openImageModal = (speaker) => {
    setSelectedImage(speaker.image);
    setSelectedSpeaker(speaker);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setSelectedSpeaker(null);
  };

  const SpeakerCard = ({ speaker }) => {
    const getStatusClass = () => {
      switch(speaker.status) {
        case 'Confirmed': return 'status-confirmed';
        case 'In View': return 'status-inview';
        case 'Invited': return 'status-invited';
        case 'Dispatched': return 'status-dispatched';
        case 'Special Guest': return 'status-special';
        default: return '';
      }
    };

    const getInitials = (name) => {
      return name.split(' ').map(word => word[0]).join('').substring(0, 2).toUpperCase();
    };

    return (
      <div className="speaker-card" onClick={() => openImageModal(speaker)}>
        <div className="speaker-image-container">
          <img 
            src={speaker.image} 
            alt={speaker.name}
            className="speaker-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.querySelector('.speaker-initials').style.display = 'flex';
            }}
          />
          <div className="speaker-initials" style={{ display: 'none' }}>
            {getInitials(speaker.name)}
          </div>
          <div className={`speaker-status-badge ${getStatusClass()}`}>
            {speaker.status}
          </div>
          {speaker.isChairman && (
            <div className="speaker-chairman-badge">
              <span>👤</span> Chairman
            </div>
          )}
        </div>
        <div className="speaker-info">
          <h3 className="speaker-name">{speaker.name}</h3>
          <p className="speaker-title">{speaker.title}</p>
          <p className="speaker-org">{speaker.organization}</p>
          <div className="speaker-topic">
            <span className="topic-label">Topic:</span>
            <span className="topic-text">{speaker.topic}</span>
          </div>
        </div>
      </div>
    );
  };

  const ImageModal = () => {
    if (!selectedImage || !selectedSpeaker) return null;

    return (
      <div className="speaker-modal-overlay" onClick={closeImageModal}>
        <div className="speaker-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="speaker-modal-close" onClick={closeImageModal}>×</button>
          <div className="speaker-modal-grid">
            <div className="speaker-modal-image">
              <img src={selectedImage} alt={selectedSpeaker.name} />
            </div>
            <div className="speaker-modal-details">
              <h2>{selectedSpeaker.name}</h2>
              <p className="modal-title">{selectedSpeaker.title}</p>
              <p className="modal-org">{selectedSpeaker.organization}</p>
              <div className="modal-topic">
                <strong>Topic:</strong>
                <p>{selectedSpeaker.topic}</p>
              </div>
              <div className="modal-status">
                <span className="status-label">Status:</span>
                <span className={`modal-status-badge ${selectedSpeaker.status === 'Confirmed' ? 'status-confirmed' : selectedSpeaker.status === 'In View' ? 'status-inview' : selectedSpeaker.status === 'Invited' ? 'status-invited' : selectedSpeaker.status === 'Dispatched' ? 'status-dispatched' : 'status-special'}`}>
                  {selectedSpeaker.status}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getTotalSpeakers = () => {
    const total = speakers.confirmed.length + speakers.inView.length + speakers.invited.length + speakers.specialGuest.length + speakers.chairman.length;
    return total;
  };

  return (
    <div className="speakers-page">
      {/* Hero Section */}
      <div className="speakers-hero">
        <div className="speakers-hero-overlay"></div>
        <div className="speakers-hero-content">
          <span className="speakers-hero-badge">AICIS 2026</span>
          <h1>Global Summit Speakers</h1>
          <p className="speakers-hero-subtitle">
            Distinguished leaders, policymakers, and experts shaping Africa's sustainable future
          </p>
          <div className="speakers-stats">
            <div className="stat-item">
              <span className="stat-number">{speakers.confirmed.length + speakers.chairman.length}</span>
              <span className="stat-label">Confirmed</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">{speakers.invited.length}</span>
              <span className="stat-label">Invited</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">{speakers.inView.length}</span>
              <span className="stat-label">In View</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">{getTotalSpeakers()}</span>
              <span className="stat-label">Total</span>
            </div>
          </div>
        </div>
      </div>

      <div className="speakers-container">
        {/* Special Guest Section */}
        {speakers.specialGuest.length > 0 && (
          <section className="speakers-section special-guests">
            <div className="section-header">
              <h2>Special Guest of Honour</h2>
              <div className="section-line"></div>
            </div>
            <div className="speakers-grid special-grid">
              {speakers.specialGuest.map(speaker => (
                <SpeakerCard key={speaker.id} speaker={speaker} />
              ))}
            </div>
          </section>
        )}

        {/* Chairman Section */}
        {speakers.chairman.length > 0 && (
          <section className="speakers-section chairman-section">
            <div className="section-header">
              <h2>Chairman of the Occasion</h2>
              <div className="section-line"></div>
            </div>
            <div className="speakers-grid chairman-grid">
              {speakers.chairman.map(speaker => (
                <SpeakerCard key={speaker.id} speaker={speaker} />
              ))}
            </div>
          </section>
        )}

        {/* Confirmed Speakers Section */}
        <section className="speakers-section confirmed">
          <div className="section-header">
            <h2>Confirmed Speakers</h2>
            <div className="section-line"></div>
            <p className="section-description">
              Distinguished leaders and experts confirmed to speak at the AICIS 2026 Global Summit
            </p>
          </div>
          <div className="speakers-grid">
            {speakers.confirmed.map(speaker => (
              <SpeakerCard key={speaker.id} speaker={speaker} />
            ))}
          </div>
        </section>

        {/* Invited Speakers Section */}
        <section className="speakers-section invited">
          <div className="section-header">
            <h2>Invited Speakers</h2>
            <div className="section-line"></div>
            <p className="section-description">
              Distinguished personalities invited to participate in the Summit
            </p>
          </div>
          <div className="speakers-grid">
            {speakers.invited.map(speaker => (
              <SpeakerCard key={speaker.id} speaker={speaker} />
            ))}
          </div>
        </section>

        {/* In View Section */}
        {speakers.inView.length > 0 && (
          <section className="speakers-section inview">
            <div className="section-header">
              <h2>In View</h2>
              <div className="section-line"></div>
              <p className="section-description">
                Distinguished personalities currently being considered for participation
              </p>
            </div>
            <div className="speakers-grid">
              {speakers.inView.map(speaker => (
                <SpeakerCard key={speaker.id} speaker={speaker} />
              ))}
            </div>
          </section>
        )}

        {/* Back Navigation */}
        <div className="speakers-back">
          <Link to="/activities" className="back-button">
            <span className="back-icon">←</span> Back to Activities
          </Link>
        </div>

        {/* Expression of Interest Button */}
        <div className="speakers-eoi-section">
          <div className="eoi-divider">
            <span className="eoi-divider-line"></span>
            <span className="eoi-divider-text">Join the Planning Committee</span>
            <span className="eoi-divider-line"></span>
          </div>
          <div className="eoi-content">
            <h3>Express Interest in Joining the AICIS 2026 Planning Committee</h3>
            <p>
              Qualified professionals, serving and retired public officers, institutional representatives, 
              and international development practitioners are invited to contribute their expertise.
            </p>
            <Link to="/speakers-form" className="eoi-btn">
              <span className="eoi-btn-icon">📋</span>
              Submit Expression of Interest
              <span className="eoi-btn-arrow">→</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <ImageModal />
    </div>
  );
};

export default Speakers;